import React from "react";
import { ModalProvider } from "./src/hooks/ModalContext";
import {GatsbyBrowser} from "gatsby";
import "./src/styles/global.scss";
import '@fontsource-variable/montserrat';
import '@fontsource-variable/bodoni-moda';
import "@fontsource/bentham";

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({ element }) => (
    <ModalProvider>{element}</ModalProvider>
);